import { createContext } from "react"

import { GridSortModel } from "@mui/x-data-grid"

import { undefinedFunctionWarning } from "@l2r-front/l2r-utils"

export type CampaignDetailViewMode = "map" | "table"

export interface CampaignDetailStateType {
    viewMode: CampaignDetailViewMode
    sortModel: GridSortModel
    sortHistory: string[]
}

export interface CampaignDetailDispatchType {
    setViewMode: (_viewMode: CampaignDetailViewMode) => void
    setSort: (_sortModel: GridSortModel, _sortHistory: string[]) => void
}

export const initialState: CampaignDetailStateType = {
    viewMode: "map",
    sortModel: [],
    sortHistory: [],
}

const initialDispatch: CampaignDetailDispatchType = {
    setViewMode: undefinedFunctionWarning("setViewMode"),
    setSort: undefinedFunctionWarning("setSort"),
}

export const CampaignDetailStateContext = createContext<CampaignDetailStateType>(initialState)
export const CampaignDetailDispatchContext = createContext<CampaignDetailDispatchType>(initialDispatch)
